/**
 * Google AdSense publisher config for the marketing site.
 *
 * Where ads may appear is decided per route in src/seo/routes.json (ads:true).
 * Only content pages with well over 250 words of main text carry the flag.
 * Policy pages (privacy, terms, legal FAQ, contact) and thin templates
 * (download, status, auth, dashboard, settings, 404) never load the AdSense
 * script and never render an ad unit.
 *
 * Manual ad units also need a real ad-unit id. While ADSENSE_AD_UNIT_ID is
 * empty, <AdSenseSlot> renders nothing at all: no placeholder box, no empty
 * "slot available" frame.
 */
export const ADSENSE_CLIENT_ID = 'ca-pub-1147071442758508'
export const ADSENSE_PUBLISHER_ID = 'pub-1147071442758508'
export const ADSENSE_SCRIPT_SRC =
  `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`

/** Empty until an AdSense display unit is created; the slot renders nothing until then. */
export const ADSENSE_AD_UNIT_ID = ''

export const ADSENSE_ENABLED = Boolean(ADSENSE_CLIENT_ID)
